import { useState } from "react";
import { Sparkles } from "lucide-react";
import { API } from "../lib/api";
import { Btn } from "./common";

export function AIExplain({ kind, payload, testid = "ai-explain" }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true); setText("");
    try {
      const res = await fetch(`${API}/ai/explain`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ kind, payload }) });
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        setText((t) => t + dec.decode(value, { stream: true }));
      }
    } catch (e) { setText("AI explanation unavailable."); }
    setBusy(false);
  };
  return (
    <div data-testid={testid}>
      <Btn variant="ghost" onClick={run} disabled={busy} data-testid={`${testid}-btn`}><Sparkles className="h-3.5 w-3.5 text-violet-600" />{busy ? "Thinking…" : "AI explain (EN/BM)"}</Btn>
      {text && <div data-testid={`${testid}-text`} className="mt-2 whitespace-pre-wrap rounded-sm border border-violet-500/20 bg-violet-500/5 p-3 text-xs leading-relaxed text-slate-700">{text}</div>}
    </div>
  );
}
